import React from 'react';
import { Outlet } from 'react-router-dom';
import { useBreakpoint } from '../hooks/useBreakpoint';
import MobileBottomNav from './MobileBottomNav';
import MobileTopBar from './MobileTopBar';
import DesktopSidebar from './DesktopSidebar';
import { NotificationDrawerProvider } from './NotificationDrawer/NotificationDrawerContext.jsx';
import NotificationDrawer from './NotificationDrawer/NotificationDrawer.jsx';
import './AppShell.less';

/**
 * AppShell — the authenticated dashboard chrome. Composed as a
 * layout route so only dashboard surfaces (home, /charge form,
 * history, vehicles, profile, settings, support) inherit it. The
 * standalone charger flow (/c/:code, /station, /charge/active)
 * lives on sibling routes OUTSIDE this component and gets the full
 * viewport for its own layout.
 *
 * NotificationDrawerProvider wraps the shell so the bell button in
 * MobileTopBar / DesktopSidebar can open the drawer without prop
 * drilling. The drawer itself is mounted once here so the current
 * page (via <Outlet />) stays underneath — the customer never
 * navigates away to read notifications.
 */
function AppShell() {
  const bp = useBreakpoint();

  return (
    <NotificationDrawerProvider>
      <div className={`gc-app-shell gc-bp-${bp}`}>
        <a href="#gc-main-content" className="gc-skip-link">Skip to content</a>

        {bp === 'desktop' && <DesktopSidebar />}
        {bp === 'tablet' && <DesktopSidebar rail />}

        <div className="gc-app-shell-main">
          {bp === 'mobile' && <MobileTopBar />}

          <main id="gc-main-content" className="gc-app-shell-content" tabIndex={-1}>
            <Outlet />
          </main>

          {bp === 'mobile' && <MobileBottomNav />}
        </div>

        <NotificationDrawer />
      </div>
    </NotificationDrawerProvider>
  );
}

export default AppShell;
